<template>
  <div>
    <div class="row hidden-xs"></div>
    <div class="container">
      <div class="row" style="padding-bottom: 80px;">
        <div class="col-xs-12">
          <h2 class="text-primary" v-if="false">Verificação do AR-Online</h2>
          <hr>

          <tabs>
            <tab title="Resumo">
              <hr>
              <AppInfoEmailSummary
                :subject="subject"
                :remetente="remetente"
                :destinatario="destinatario"
                :content="content"
                :dataEnviada="dataEnviada"
                :horaEnviada="horaEnviada"
                :dataEntrega="dataEntrega"
                :horaEntrega="horaEntrega"
                :dataLeitura="dataLeitura"
                :horaLeitura="horaLeitura"
                :idImage="idImage"
                :dataLeituraUTC="dataLeituraUTC"
                :emailSent="emailSent"
                :numeroCelular="numeroCelular"
                :mensagem="mensagem"
                :smsSent="smsSent"
                :dataEnvioSMS="dataEnvioSMS"
                :dataLeituraSMS="dataLeituraSMS"
                :statusSMS="statusSMS"
              />
            </tab>

            <tab title="E-mail" v-if="emailSent">
              <hr>
              <AppInfoEmailBry
                v-if="provider === 'bry' && !loading"
                :detalhesLeitura="detalhesLeitura"
                :detalhesEnvioEntrega="detalhesEnvioEntrega"
              />

              <AppInfoEmailQualisoft
                v-if="provider === 'qualisoft' && !loading"
                :emailRawDecoded="emailRawDecoded"
                :carimboEmail="carimboEmail"
                :carimboEmailEnvio="carimboEmailEnvio"
                :carimboEmailEntregue="carimboEmailEntregue"
              />
            </tab>

            <tab title="SMS" v-if="smsSent">
              <hr>
              <AppInfoSMS
                :detalhesEnvioEntregaSMS="detalhesEnvioEntregaSMS"
              />
            </tab>

          </tabs>
          <div class="" style="margin-bottom: 25px;"></div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import { Tabs, Tab } from 'uiv'
import AppInfoEmailSummary from './InfoEmailSummary'
import AppInfoEmailQualisoft from './provider-qualisoft/InfoEmailQualisoft.vue'
import AppInfoEmailBry from './provider-bry/InfoEmailBry'
import AppInfoSMS from './provider-sms/InfoSMS'

export default {
  name: 'AppInfo',

  data () {
    return {
      status: ''
    }
  },

  props: {
    subject: {
      type: String,
      required: true
    },
    remetente: {
      type: String,
      required: true
    },
    destinatario: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    dataEnviada: {
      type: String,
      required: true
    },
    horaEnviada: {
      type: String,
      required: true
    },
    dataEntrega: {
      type: String,
      required: true
    },
    horaEntrega: {
      type: String,
      required: true
    },
    dataLeitura: {
      type: String
    },
    horaLeitura: {
      type: String
    },
    idImage: {
      type: String
    },
    dataLeituraUTC: {
      type: String
    },
    emailRawDecoded: {
      type: String
    },
    carimboEmail: {
      type: Object
    },
    detalhesLeitura: {
      type: Object
    },
    // Remover o abaixo
    carimboEmailEnvio: {
      type: Object
    },
    carimboEmailEntregue: {
      type: Object
    },
    detalhesEnvioEntrega: {
      type: Object
    },
    provider: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    emailSent: {
      type: Boolean,
      required: true
    },
    smsSent: {
      type: Boolean,
      required: true
    },
    numeroCelular: {
      type: String
    },
    mensagem: {
      type: String
    },
    dataEnvioSMS: {
      type: String
    },
    dataLeituraSMS: {
      type: String
    },
    statusSMS: {
      type: String
    },
    detalhesEnvioEntregaSMS: {
      type: Object
    },
    detalhesLeituraSMS: {
      type: Object
    }
  },

  components: {
    Tabs,
    Tab,
    AppInfoEmailSummary,
    AppInfoEmailQualisoft,
    AppInfoEmailBry,
    AppInfoSMS
  }

}

</script>
<style>
  body {
    height: 100vh;
  }
  .scroll-top-wrapper.show {
    display: none !important;
  }
  .swal2-container {
    z-index: 99999999;
  }
  pre {
    margin: 20px;
  }
  #carimbo {
    white-space: pre-wrap;
  }
  .carimbo {
    height: auto;
    max-height: 400px;
    overflow: auto;
    background-color: #eeeeee;
    word-break: normal !important;
    word-wrap: normal !important;
    white-space: pre !important;
  }

  @media (max-width:767px){
    .panel-body table * {
      width: 100% !important;
      table-layout: fixed !important;
    }
    .es-wrapper-color{zoom: 50%;}
    .panel-body table a img {
        width: 20px !important;
    }
    img[alt="Carta de Notificação de Regsitro"] {
      height: 180px !important;
    }
    img[alt="Homem feliz"] {
      height: 110px !important;
      width: 130px !important;
    }

    div > div.container-fluid > div:nth-child(2) > div.container > div > div > div:nth-child(3) > div:nth-child(2) > div.panel-body > div > table > tbody > tr > td > table:nth-child(3) > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table.es-right > tbody > tr > td > table > tbody > tr > td > p {
      padding-top: 0px;
      padding-right: 0px;
    }
    div > div.container-fluid > div:nth-child(2) > div.container > div > div > section > div > div.tab-pane.fade.active.in > div > div:nth-child(2) > div.panel-body > div.es-wrapper-color > table > tbody > tr > td > table:nth-child(2) > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table > tbody > tr:nth-child(1) > td > table > tbody > tr > td > table > tbody > tr > td > p strong {
      overflow-wrap: break-word !important;
    }
    div > div.container-fluid > div:nth-child(2) > div.container > div > div > section > div > div.tab-pane.fade.active.in > div > div:nth-child(2) > div.panel-body > div.es-wrapper-color > table > tbody > tr > td > table:nth-child(2) > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table > tbody > tr:nth-child(2) > td > table > tbody > tr > td > table > tbody > tr > td > p {
      overflow-wrap: break-word !important;
      font-size: 12px;
    }
    li {
      overflow-wrap: break-word !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Info.vue